<template>
<!-- 咨询方案 -->
  <div class="plan-main">
      <div class="title-box">
          <div class="bdr"></div>其他你希望告诉职业咨询师的…
      </div>
      <!-- 课程 -->
      <div v-for="(item,index) in planList" :key="index" class="row">
          <label for="">{{item.name}}</label>
          <van-switch @input="counterCountHandle(item,index)" :value="item.bool" class="switch-plan"  />
      </div>
      <!-- 咨询次数 -->
      <div class="plan-cpunt">
          <div class="bdr"></div>咨询次数
          <div class="counter">
              <div class="left" @click="removeCounterCount()">-</div>
              <div class="center">{{counterCount}}</div>
              <div class="right" @click="addCounterCount()">+</div>
          </div>
      </div>
      <!--  -->
      <div class="footer">
        <button @click="saveHandle()">完成</button>
      </div>
  </div>
</template>

<script>
import { extensionAdd,userInfo,extensionGet,extensionSave } from "@/api/xuandui_gadgets";
import { shareCon } from "@/utils/wxconfig";
import { deepCopy } from "@/utils/tools";
export default {
    data(){
        return{
            // 咨询课程
            planList:[],
            // 咨询次数
            counterCount:1,
            // 已生成方案服务
            orderPlanList:[]
        }
    },
    methods:{
        // 根据咨询次数限制可选择咨询方案的个数
        counterCountHandle(item,index){
            let num = 0;
            this.planList.map(v=>{
                if(v.bool){
                    num+=1;
                }
            });
            if(this.counterCount==1 && num>=4){
                this.$toast('1次咨询只可以选择4个哦~');
                return
            }else if(this.counterCount==2 && num>=6){
                this.$toast('2次咨询只可以选择6个哦~');
                return
            }else if(this.counterCount==3 && num>=9){
                this.$toast('3次咨询只可以选择9个哦~');
                return
            }
            this.$set(this.planList[index],'bool',!item.bool);
        },
        // 提交方案
        saveHandle(){
            //调用加载中
            this.$emit("loadingHandle", true, "提交方案中...");
            let q = this.$route.query;
            // 处理接口所需数据格式
            let detailsObj = {};
            this.planList.map(v=>{
                if(v.bool){
                    detailsObj[v.name] = 1;
                }
            });
            
            detailsObj['服务次数'] = this.counterCount;
            
            let obj = {
                detail:JSON.stringify(detailsObj)
            };
            // 转化为分
            if(this.counterCount==1){
                obj['price'] = 399*100;
            }
            //第二次咨询打九折 转化为分
            if(this.counterCount==2){
                obj['price'] = ((399*2)*0.9) * 100;
            }
            //第三次咨询打八折 转化为分
            if(this.counterCount==3){
                obj['price'] = ((399*3)*0.8) * 100;
            }
            if(q.id){
                obj['id'] = q.id;
                extensionSave(obj).then((data) => {
                    //关闭加载中
                    this.$emit("loadingHandle", false);
                    if (data.error > 0) {
                        this.$toast(data.detail || data.msg);
                        return;
                    }
                    this.$router.push('/xd_consult_order?id='+data.item.id);
                });
            }else{
                extensionAdd(obj).then((data) => {
                    //关闭加载中
                    this.$emit("loadingHandle", false);
                    if (data.error > 0) {
                        this.$toast(data.detail || data.msg);
                        return;
                    }
                    this.$router.push('/xd_consult_order?id='+data.id);
                });
            }
        },
        // 减少咨询次数
        removeCounterCount(){
            if(this.counterCount<=1){
                return
            }
            this.planList  = this.planList.map(v=>{
                v.bool = false;
                return v
            });
            this.counterCount-=1;
        },
        // 添加咨询次数
        addCounterCount(){
            if(this.counterCount>=3){
                return
            }
            this.counterCount+=1;
        },
        // 初始化获取数据
        pullData(){
            document.title = '咨询方案';
            shareCon("index", this);
            let q = this.$route.query;
            userInfo().then((data)=>{
                if(data.error>0){
                    this.$toast(data.msg);
                    return
                }
            });
            this.planList = [
                {   
                    name:'测评解读',
                    bool:false
                },
                {   
                    name:'能力资源盘点',
                    bool:false
                },
                {   
                    name:'优势梳理',
                    bool:false
                },
                {   
                    name:'兴趣方向确定',
                    bool:false
                },
                {   
                    name:'行职业信息支持',
                    bool:false
                },
                {   
                    name:'职场关系处理',
                    bool:false
                },
                {   
                    name:'确定职业方向',
                    bool:false
                },
                {   
                    name:'行动方案制定',
                    bool:false
                },
                {   
                    name:'简历优化',
                    bool:false
                },
                {   
                    name:'面试辅导',
                    bool:false
                }
            ];
            // 判断是否是存在id，如果存在则为修改
            if(q.id){
                //调用加载中
                this.$emit("loadingHandle", true, "获取方案中...");
                document.title = '咨询方案';
                extensionGet({
                    id:q.id
                }).then((data)=>{
                    //关闭加载中
                    this.$emit("loadingHandle", false);
                    if(data.error>0){
                        this.$toast(data.msg);
                        return
                    }
                    if(data.item.detail && JSON.parse(data.item.detail)){
                        let obj = JSON.parse(data.item.detail);
                        let keys = Object.keys(JSON.parse(data.item.detail));
                        // 循环赋值已选咨询方案
                        this.planList.map(p=>{
                            keys.map(v=>{
                                if(v=='服务次数'){
                                    this.counterCount = obj[v];
                                }else{
                                    if(p.name==v){
                                        p.bool = true;
                                        return
                                    }
                                }
                            });
                        });
                        
                    }

                });
            }
            
        }
    },
    created(){
        this.pullData();
    }
}
</script>
<style lang="scss">
    body{
        background-color: #ffffff;
    }
</style>
<style lang="scss" scoped>
.plan-main{
    position: relative;
    padding-bottom: 120px;
    .title-box{
        display: flex;
        align-items: center;
        padding: 0 30px;
        height: 98px;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #2B333A;
        margin-top: 20px;
        .bdr{
            width: 6px;
            height: 30px;
            background: #46A3FA;
            border-radius: 6px;
            margin-right: 20px;
        }
    }
    .row{
        margin: 0 30px;
        padding: 0 30px;
        box-sizing: border-box;
        height: 98px;
        display: flex;
        align-items: center;
        margin-bottom: 2px;
        &:last-of-type{
            margin-bottom: 22px;
        }
        label{
            font-size: 30px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #2B333A;
            line-height: 46px;
        }
        .switch-plan{
            margin-left: auto;
            font-size: 30px !important;
            line-height: 46px;
        }
    }
    .plan-cpunt{
        display: flex;
        align-items: center;
        padding: 0 30px;
        height: 98px;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #2B333A;
        margin-top: 20px;
        margin-bottom: 12px;
        .bdr{
            width: 6px;
            height: 30px;
            background: #46A3FA;
            border-radius: 6px;
            margin-right: 20px;
        }
        .counter{
            margin-left: auto;
            display: flex;
            align-items: center;
            overflow: hidden;
            height: 34;
            font-size: 0;
            .left{
                width: 34px;
                text-align: center;
                border: 2px solid #D6D6D6;
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #7C828A;
                border-top-left-radius: 8px;
                border-bottom-left-radius: 8px;
            }
            .right{
                width: 34px;
                text-align: center;
                border: 2px solid #D6D6D6;
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #7C828A;
                border-top-right-radius: 8px;
                border-bottom-right-radius: 8px;
            }
            .center{
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #7C828A;
                width: 48px;
                text-align: center;
                border-top: 2px solid #d6d6d6;
                border-bottom: 2px solid #d6d6d6;
            }
        }
    }
    .footer{
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        max-width: 750px;
        background-color: #FFFFFF;
        button{
            width: 670px;
            height: 80px;
            background: #46A3FA;
            border-radius: 40px;
            font-size: 32px;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 44px;
            letter-spacing: 1px;
            border: none;
        }
    }
}
</style>